import storage, {CUSTOM_INPUT_OPTION_MODE} from './ValueSourceOptionsGroupStorage'

const bool_options = [{
    label: 'true',
    value: 'true',
}, {
    label: 'false',
    value: 'false',
},]

const NAME = 'name'
const PRICE = 'price'
const SUMMARY = 'summary'
const COUNT = 'count'

class ValueSourceOptionsGroupsFactory {

    /**
     * @param {String} field
     * @return {Array<ValueSourceOptionsGroup>}
     */
    getForDataset(field) {
        const field_groups = this._collectForField(field)
            .filter(group => group.isEmpty() || group.isDefault() || group.options.length > 0)

        if (this._canFieldHaveExternalSource(field)) {
            for (const external_group of storage.getExternalValueOptionsGroups()) {
                field_groups.push(external_group)
            }
        }

        return field_groups
    }

    _canFieldHaveExternalSource(field) {
        return ![
            'vendor_model_model_template',
            'simple_name_template',
        ].includes(field)
    }

    /**
     * @param field
     * @return {Array<ValueSourceOptionsGroup>}
     */
    _collectForField(field) {
        if (Array.isArray(field)) {
            let groups = [];
            for (const fieldElement of field) {
                let group =this._collectForField(fieldElement);
                groups = [...groups, ...group]
            }
            return groups;
        }
        if (field === 'DEFAULT') {
            return this._collectDefaultDataSet()
        }
        if (field === 'VAT') {
            return this._collectVatOptionsGroups()
        }
        if (field === 'PRICE') {
            return this._collectPriceOptionsGroups()
        }
        if (field === 'IMAGE_COUNT') {
            return this._collectImagesLimitOptionsGroups()
        }
        if (field === 'CHOOSE_OFFER_NAME') {
            return this._collectNameTemplateOptionsGroups()
        }
        if (field === 'CHOOSE_OFFER_TYPE') {
            return this._collectOfferTypeOptionsGroups()
        }
        if (field === 'ADDITIONAL_PRICE' || field === 'ADDITIONAL_PRICE2') {
            return this._collectAdditionalPriceTypeOptionsGroups()
        }
        if (field === "DEFAULT_BOOL") {
            return this._collectDefaultBoolOptionsGroups()
        }
        if (field === "SWITCH") {
            return this._collectSwitchOptionsGroups()
        }
        if (field === "VALUE_CHOOSE_IMAGE_SIZE") {
            return this._collectImageSizes()
        }
        if (field === "custom_param") {
            return this._collectCustomParamOptionsGroups()
        }
        if (field === "VALUE_CHOOSE_DELIVERY_WEEKDAYS") {
            return this._collectDeliveryWeekdays()
        }
        if (field === "THE_COUNT") {
            return this._collectCountOptionsGroups()
        }
        if (field === 'CONDITION_TYPE') {
            return this._collectConditionTypeOptionsGroups()
        }
        if (field === 'CONDITION_QUALITY') {
            return this._collectConditionQualityOptionsGroups()
        }
        if (field === 'BY_DEFAULT') {
            return this._collectByDefault()
        }
        if (field === 'WEIGHT_UNIT') {
            return this._collectWeightUnitOptionsGroups()
        }

        if (field === 'STRING') {
            return this._collectString()
        }
        console.warn(`не указан набор групп значений для поля ${field}`)

        return []
    }

    _collectString() {
        return [
            storage.getEmptyValueOptionsGroup(),
            storage.getSpecificValueOptionsGroup()
        ]
    }

    _collectByDefault() {
        return [
            storage.getDefaultValueOptionsGroup()
        ]
    }
    _collectDeliveryWeekdays() {
        return [
            storage.getEmptyValueOptionsGroup(),
            storage.getDeliveryWeekdays(),
            storage.getSpecificValueOptionsGroup(),
            storage.getProductWithIdsFieldValueOptionsGroup(),
            storage.getProductFeaturesValueOptionsGroup(),
        ]
    }
    _collectWeightUnitOptionsGroups() {
        return [
            storage.getEmptyValueOptionsGroup('По умолчанию'),
            storage.getUnitOptionGroup()
        ]
    }
    _collectAdditionalPriceTypeOptionsGroups() {
        return [
            storage.getEmptyValueOptionsGroup(),
            storage.getAdditionalTypeOptionGroup()
        ]
    }

    _collectOfferTypeOptionsGroups() {
        return [
            storage.getOfferTypeOptionsGroup()
        ]
    }
    _collectCountOptionsGroups() {
        return [
            storage.getCountValueOptionsGroup(),
        ]
    }
    _collectModelTemplateOptionsGroups() {
        return [
            storage.getVendorModelTemplateOptionsGroup(),
        ]
    }

    _collectNameTemplateOptionsGroups() {
        return [
            storage.getSimpleNameTemplateOptionsGroup(),
        ]
    }

    _collectNameOptionsGroups() {
        return [
            storage.getEmptyValueOptionsGroup(),
            storage.getSpecificValueOptionsGroup(),
            storage.getProductFieldValueOptionsGroup(NAME),
            storage.getProductFeaturesValueOptionsGroup(),
        ]
    }

    _collectTypePrefixOptionsGroups() {
        return [
            storage.getEmptyValueOptionsGroup(),
            storage.getSpecificValueOptionsGroup(),
            storage.getDefaultValueOptionsGroup(),
            storage.getProductFieldValueOptionsGroup(),
            storage.getProductFeaturesValueOptionsGroup(),
        ]
    }

    _collectPriceOptionsGroups() {
        return [
            storage.getEmptyValueOptionsGroup(),
            storage.getSpecificValueOptionsGroup(),
            storage.getProductPricesValueOptionsGroup(PRICE),
            storage.getProductFeaturesValueOptionsGroup(),
        ]
    }

    _collectDefaultBoolOptionsGroups() {
        return [
            storage.getEmptyValueOptionsGroup(),
            storage.getSpecificValueOptionsGroup(bool_options),
            storage.getProductFieldValueOptionsGroup(),
            storage.getProductFeaturesValueOptionsGroup(),
        ]
    }

    _collectStoreOptionsGroups() {
        return [
            storage.getEmptyValueOptionsGroup(),
            storage.getDefaultValueOptionsGroup(),
            storage.getSpecificValueOptionsGroup(bool_options),
            storage.getProductFieldValueOptionsGroup(),
            storage.getProductFeaturesValueOptionsGroup(),
        ]
    }

    _collectDescriptionOptionsGroups() {
        return [
            storage.getEmptyValueOptionsGroup(),
            storage.getSpecificValueOptionsGroup(),
            storage.getProductFieldValueOptionsGroup(SUMMARY),
            storage.getProductFeaturesValueOptionsGroup(),
        ]
    }

    _collectManufacturerWarrantyOptionsGroups() {
        return [
            storage.getEmptyValueOptionsGroup(),
            storage.getSpecificValueOptionsGroup(bool_options),
            storage.getProductFieldValueOptionsGroup(),
            storage.getProductFeaturesValueOptionsGroup(),
        ]
    }

    _collectAdultOptionsGroups() {
        return [
            storage.getEmptyValueOptionsGroup(),
            storage.getSpecificValueOptionsGroup(bool_options),
            storage.getProductFieldValueOptionsGroup(),
            storage.getProductFeaturesValueOptionsGroup(),
        ]
    }

    _collectCpaOptionsGroups() {
        const condition_options = [{
            label: 'Да',
            value: '1',
        }, {
            label: 'Нет',
            value: '0',
        },]

        return [
            storage.getEmptyValueOptionsGroup(),
            storage.getSpecificValueOptionsGroup(condition_options, CUSTOM_INPUT_OPTION_MODE.CUSTOM_ONLY),
            storage.getProductFeaturesValueOptionsGroup(),
        ]
    }

    _collectConditionTypeOptionsGroups() {
        const condition_options = [
        //     {
        //     label: 'likenew — как новый (товар не был в употреблении, уценен из-за недостатков)',
        //     value: 'likenew',
        // }, {
        //     label: 'used — подержанный (товар был в употреблении)',
        //     value: 'used',
        // },
            {
                label: 'бывший в употреблении, раньше принадлежал другому человеку',
                value: 'preowned',
            },{
                label: 'витринный образец',
                value: 'showcasesample',
            },{
                label: 'уцененный товар',
                value: 'reduction',
            },{
                label: 'восстановленный (указывается только для одежды и аксессуаров)',
                value: 'refurbished ',
            },]

        return [
            storage.getSpecificValueOptionsGroupOnlyCustom(condition_options),
        ]
    }

    _collectConditionQualityOptionsGroups() {
        const condition_options = [{
            label: 'как новый, товар в идеальном состоянии',
            value: 'perfect',
        }, {
            label: 'отличный, следы использования или дефекты едва заметные',
            value: 'excellent',
        },{
            label: 'хороший, есть заметные следы использования или дефекты',
            value: 'good',
        },]

        return [
            storage.getSpecificValueOptionsGroupOnlyCustom(condition_options),
        ]
    }

    _collectAvailableOptionsGroups() {
        return [
            storage.getEmptyValueOptionsGroup(),
            storage.getSpecificValueOptionsGroup(bool_options),
            storage.getProductFieldValueOptionsGroup(COUNT),
            storage.getProductFeaturesValueOptionsGroup(),
        ]
    }


    _collectDownloadableOptionsGroups() {
        return [
            storage.getEmptyValueOptionsGroup(),
            storage.getSpecificValueOptionsGroup(bool_options),
            storage.getProductFieldValueOptionsGroup(),
            storage.getProductFeaturesValueOptionsGroup(),
        ]
    }


    _collectCustomParamOptionsGroups() {
        return [
            storage.getEmptyValueOptionsGroup(),
            storage.getProductFeaturesValueOptionsGroup(),
        ]
    }


    _collectDefaultDataSet() {
        return [
            storage.getEmptyValueOptionsGroup(),
            storage.getSpecificValueOptionsGroup(),
            storage.getProductWithIdsFieldValueOptionsGroup(),
            storage.getUserFormatSku(),
            storage.getProductFeaturesValueOptionsGroup(),
        ]
    }

    _collectVatOptionsGroups() {
        return [
            storage.getEmptyValueOptionsGroup(),
            storage.getVatOptions(),
            storage.getProductFeaturesValueOptionsGroup(),
        ]
    }

    _collectImagesLimitOptionsGroups() {
        const limit_options = [{
            label: '10 изображений (максимум для Яндекс.Маркет)',
            value: '10',
        }, {
            label: 'Все изображения',
            value: 'all',
        },]

        return [
            storage.getEmptyValueOptionsGroup('Не выгружать'),
            storage.getSpecificValueOptionsGroup(limit_options, CUSTOM_INPUT_OPTION_MODE.CUSTOM_LAST),
        ]
    }

    _collectSwitchOptionsGroups() {
        return [
            storage.getEmptyValueOptionsGroup(),
            storage.getSwitchOptionsGroup()
        ]
    }

    _collectImageSizes() {
        return [
            storage.getEmptyValueOptionsGroup(),
            storage.getImageSizesOptionsGroup()
        ]
    }
}

const valueSourceOptionsGroupsFactory = new ValueSourceOptionsGroupsFactory()
export default valueSourceOptionsGroupsFactory